import { call, put } from "redux-saga/effects";

/* The `newRequestFunction` is a generator function in JavaScript that is used in Redux Saga to handle
asynchronous API requests. */
function* newRequestFunction(successHandler, errorHandler, apiCall, ...args) {
  if (!navigator.onLine) {
    alert("There is no internet connection")
  } else {
    try {
      const response = yield call(apiCall, ...args);
      yield put(successHandler(response));

    } catch (error) {
      yield put(errorHandler(error))
    }
  }
}

export default newRequestFunction;